import $ from 'jquery';
import sticky from 'jquery-sticky';

export default class Header {
    constructor() {
        $('.js-sticky-header').sticky({
            topSpacing: 0,
            zIndex: 10
        });
    };
};
